import * as React from 'react'

const Drivers = (props: { className: string }) => {
  return (
    <svg className={'icon ' + props.className} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
      <g id='Canvas'>
        <g id='Organizations' clipPath='url(#clip0)'>
          <path
            d='M 12 4.88889L 12 0L 0 0L 0 22L 24 22L 24 4.88889L 12 4.88889ZM 4.8 19.5556L 2.4 19.5556L 2.4 17.1111L 4.8 17.1111L 4.8 19.5556ZM 4.8 14.6667L 2.4 14.6667L 2.4 12.2222L 4.8 12.2222L 4.8 14.6667ZM 4.8 9.77778L 2.4 9.77778L 2.4 7.33333L 4.8 7.33333L 4.8 9.77778ZM 4.8 4.88889L 2.4 4.88889L 2.4 2.44444L 4.8 2.44444L 4.8 4.88889ZM 9.6 19.5556L 7.2 19.5556L 7.2 17.1111L 9.6 17.1111L 9.6 19.5556ZM 9.6 14.6667L 7.2 14.6667L 7.2 12.2222L 9.6 12.2222L 9.6 14.6667ZM 9.6 9.77778L 7.2 9.77778L 7.2 7.33333L 9.6 7.33333L 9.6 9.77778ZM 9.6 4.88889L 7.2 4.88889L 7.2 2.44444L 9.6 2.44444L 9.6 4.88889ZM 21.6 19.5556L 12 19.5556L 12 17.1111L 14.4 17.1111L 14.4 14.6667L 12 14.6667L 12 12.2222L 14.4 12.2222L 14.4 9.77778L 12 9.77778L 12 7.33333L 21.6 7.33333L 21.6 19.5556ZM 19.2 9.77778L 16.8 9.77778L 16.8 12.2222L 19.2 12.2222L 19.2 9.77778ZM 19.2 14.6667L 16.8 14.6667L 16.8 17.1111L 19.2 17.1111L 19.2 14.6667Z'
            transform='translate(0 1)'
            id='Vector'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width='24' height='24' fill='#fff' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Drivers



// WEBPACK FOOTER //
// ./src/components/icons/main-menu/Drivers.tsx